import { useAuth } from '@/context/AuthContext';

export interface AuditFields {
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  version?: number;
  is_active?: boolean;
}

export interface CreateAuditFields extends AuditFields {
  created_by: string;
  version: number;
  is_active: boolean;
}

export interface UpdateAuditFields extends AuditFields {
  updated_by: string;
}

export const useAuditFields = () => {
  const { user } = useAuth();
  
  const getCreateAuditFields = (): Partial<AuditFields> => {
    return {
      created_by: user?.id || '',
    };
  };

  const getUpdateAuditFields = (): Partial<AuditFields> => {
    return {};
  };

  const getAuditFieldsForInsert = (data: any): any => {
    // Não injeta colunas de auditoria automaticamente no INSERT.
    // Cada tabela possui schema diferente e colunas como `updated_at`
    // podem não existir (ex.: supplier_menu), gerando erro PGRST204.
    return {
      ...data,
    };
  };

  const getAuditFieldsForUpdate = (data: any): any => {
    return {
      ...data,
      ...getUpdateAuditFields(),
    };
  };

  return {
    getCreateAuditFields,
    getUpdateAuditFields,
    getAuditFieldsForInsert,
    getAuditFieldsForUpdate,
    currentUserId: user?.id,
  };
};